<template>
  <div class="admin-actions-page">
    <h3>KYC Exceptions</h3>
    <div class="admin-actions-page__input-wrp">
      <permission-wrapper
        skip-alert
        page-name="adminActions"
        resource-name="kyc_exception"
        action-name="create">
        <input-field
          class="admin-actions-page__input"
          v-model="input"
          label="Enter Email"
        />
        <button
          v-ripple
          class="app__button-raised"
          @click="submit"
        >
          {{ 'admin-actions.btn-exceptions-' + actionVerb() | globalize }}
        </button>
      </permission-wrapper>
    </div>
    <permission-wrapper
      skip-alert
      page-name="adminActions"
      resource-name="kyc_exception"
      action-name="read">
      <h4>Existing KYC exceptions</h4>
      <span
        class="admin-actions-page__exception-email"
        v-for="item in exceptionsList"
        :key="item"
      >
        <copyable :copy-text="item">{{ item }}</copyable>
      </span>
    </permission-wrapper>
  </div>
</template>

<script>
import { api } from '@/api'
import { ErrorHandler } from '@/js/helpers/error-handler'
import InputField from '../fields/InputField.vue'
import Copyable from '@/vue/common/copyable/Copyable'
import PermissionWrapper from '@/vue/common/permission-wrapper'

export default {
  name: 'admin-actions-page',
  components: {
    InputField,
    Copyable,
    PermissionWrapper,
  },
  data () {
    return {
      exceptionsList: [],
      input: '',
      label: '',
    }
  },
  async created () {
    await this.getExceptionsList()
  },
  methods: {
    async getExceptionsList () {
      try {
        const { data } = await api.getWithSignature('/admin/kyc/exceptions')
        if (data && Array.isArray(data)) {
          this.exceptionsList = data.map(exception => exception.email).sort()
        } else {
          this.exceptionsList = []
        }
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
      }
    },
    async submit () {
      try {
        let body = JSON.stringify({
          data: {
            type: 'kyc_exception',
            attributes: {
              email: this.input,
            },
          },
        })

        if (this.inputInExceptions()) {
          await api.deleteWithSignature('/admin/kyc/exceptions', body)
        } else {
          await api.postWithSignature('/admin/kyc/exceptions', body)
        }
        this.getExceptionsList()
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
      }
    },
    inputInExceptions () {
      return this.exceptionsList.includes(this.input)
    },
    actionVerb () {
      return this.inputInExceptions() ? 'remove' : 'add'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss/variables';

.admin-actions-page__input-wrp {
  margin-bottom: 3rem;
  width: 50rem;
}

.admin-actions-page__exception-email {
  display: block;
}

</style>
